import { Stepper } from "@mui/material";
import { styled } from "@mui/system";

export const StyledStepper = styled(Stepper)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  "& .MuiStepLabel-root .Mui-completed": {
    color: "#4caf50",
  },
  "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel": {
    color: theme.palette.text.secondary,
  },
  "& .MuiStepLabel-root .Mui-active": {
    color: "#13b86d",
  },
  "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel": {
    color: theme.palette.text.primary,
  },
  "& .MuiStepConnector-line": {
    borderColor:
      theme.palette.mode === "light"
        ? theme.palette.grey[300]
        : theme.palette.grey[700],
  },
}));
